<template>
  <div style="width: 100%">
    <v-data-table
      :headers="headers"
      :items="splitters"
      :loading="loading"
      loading-text=""
      :page.sync="pagination.page"
      :items-per-page="pagination.rowsPerPage"
      :items-per-page-text="$t('tables.RowsPerPage')"
      :items-per-page-items="[5, 10]"
      :header-props="{ sortIcon: 'mdi-menu-down' }"
      :footer-props="{ prevIcon: 'mdi-menu-left', nextIcon: 'mdi-menu-right' }"
      style="width: 100%"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.sp_label }}</td>

          <td>{{ splitterMaterialName(props.item) }}</td>

          <td v-if="!disabled">
            <app-datatable-action-buttons
              :user-can-edit="true"
              @edit="startEditingItem(props.item.sp_id)"
              :user-can-delete="true"
              @delete="toggleDeleteDialog(props.item.sp_id, true)"
            />
          </td>
        </tr>
      </template>
    </v-data-table>

    <splitter-edition-form
      v-if="editionFormIsOpen"
      :open="editionFormIsOpen"
      :original-item="itemToEdit"
      @close="closeItemEdition"
      @edit="editItem"
    />

    <app-dialog-box
      :open="deleteDialogIsOpen"
      :title="$t('DeleteItem')"
      :content="deleteContentMessage"
      :main-action-label="$t('No')"
      @mainAction="toggleDeleteDialog({}, false)"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="deleteItem"
    />
  </div>
</template>

<script>
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import SplitterEditionForm from "@/components/Home/Forms/_SpecialTabs/Splitters/SplitterEditionForm";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";

export default {
  name: "SplittersTable",

  components: { AppDialogBox, SplitterEditionForm, AppDatatableActionButtons },

  props: {
    splitters: {
      type: Array,
      required: true
    },

    splitterMaterialOptions: {
      type: Array,
      required: true
    },

    disabled: {
      type: Boolean,
      required: true
    },

    loading: Boolean
  },

  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 5
      },

      selectedItemIndex: null,
      editionFormIsOpen: false,
      deleteDialogIsOpen: false
    };
  },

  computed: {
    headers() {
      let headers = [
        { text: this.$i18n.tc("Label", 1), value: "sp_label" },
        { text: this.$i18n.tc("Material", 1), value: "sp_material_id" }
      ];
      if (!this.disabled) {
        headers.push({ text: "", value: "", width: "5%" });
      }
      return headers;
    },

    itemToEdit() {
      if (this.selectedItemIndex !== null) {
        return this.splitters.find(splitter => splitter.sp_id === this.selectedItemIndex);
      }
      return {};
    },

    deleteContentMessage() {
      let message = this.$i18n.t("DeleteConfirmation") + " ";
      if (this.itemToEdit && this.itemToEdit.sp_label) {
        message = message + this.itemToEdit.sp_label + "?";
      } else {
        message = message + "?";
      }
      return message;
    }
  },

  methods: {
    splitterMaterialName(splitter) {
      let splitterMaterialID = splitter.sp_material_id;
      let name = splitterMaterialID;
      if (this.splitterMaterialOptions.length > 0) {
        let splitterMaterial = this.splitterMaterialOptions.find(
          material => material.sm_id === splitterMaterialID
        );
        if (splitterMaterial) {
          name = splitterMaterial.sm_description;
          if (splitterMaterial.sm_short_description) {
            name = splitterMaterial.sm_short_description;
          }
          if (splitterMaterial.family_specific_fields) {
            let ratio =
              splitterMaterial.family_specific_fields.sms_in_ports +
              ":" +
              splitterMaterial.family_specific_fields.sms_out_ports;
            name += " (" + ratio + ")";
          }
        }
      }
      return name;
    },

    startEditingItem(index) {
      this.selectedItemIndex = index;
      this.editionFormIsOpen = true;
    },

    closeItemEdition() {
      this.selectedItemIndex = null;
      this.editionFormIsOpen = false;
    },

    editItem(updatedItem) {
      this.$emit("edit-splitter", {
        index: this.selectedItemIndex,
        data: updatedItem
      });
    },

    toggleDeleteDialog(index, open) {
      this.selectedItemIndex = index;
      this.deleteDialogIsOpen = open;
    },

    deleteItem() {
      this.$emit("delete-splitter", this.selectedItemIndex);
      this.toggleDeleteDialog(null, false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splitters/SplittersTable.vue